import { signInWithToken } from '@/services/firebase/functions/signInWithToken';
import { verifyEmail } from '@/services/firebase/functions/verifyEmail';

export const verifyEmailAndSignIn = async (confirmationCode: string) => {
  const res = await verifyEmail(confirmationCode);
  if (!res.isValid || !res.idToken) return null;
  return await signInWithToken(res.idToken);
};
